<template>
    <div class="c-budget-line">
        <div class="line-info">
            <div class="icono">
                <slot name="icon"></slot>
            </div>
            <div class="info">
                <div><slot></slot></div>
            </div>
            <div class="info-icon">
                <slot name="info">
                    <img v-b-modal="'modal-'+modalIdInfoRef" src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
                    <modal-block v-cloak title="Zona fría" :href="route('help.details','zona-fria-zona-calida')" desing="zonafria" :refer="modalIdInfoRef">
                        Te mostramos una selección de las variedades que mejor se adaptan a zonas de cultivo frías.
                    </modal-block>
                </slot>
            </div>
            <div class="change">
                <a @click="change" class="change-btn" :class="{'active': changing, 'hidden': !showChangeBtn}">Cambiar</a>
            </div>
        </div>
        <div style="width: 100%">
            <slot name="extra"></slot>
        </div>
    </div>
</template>

<script>
    import { v4 as uuidv4 } from 'uuid';

    export default {
        name: "BudgetLine",
        props: {
            changing: {
                type: Boolean,
                default: false
            },
            showChangeBtn: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                modalIdInfoRef: uuidv4(),
            }
        },
        methods: {
            change() {
                this.$emit('change-action');
            }
        }
    }
</script>

<style scoped>
    .c-budget-line .line-info {
        display: flex;
        align-items: center;
        padding: 0.7em;
        justify-content: space-between;
    }

    .c-budget-line:not(:first-child) {
        border-top: 1px solid #cbc8c8;
    }

    .c-budget-line .icon_info {
        width: 1.2em;
        color: #333333;
    }

    .change {
        margin-left: auto;
    }

    .change-btn {
        display: block;
        border-color: #0871b8;
        text-align: center;
        text-decoration: none;
        font-weight: bold;
        color: #0871b8;
        width: 100%;
        cursor: pointer;
        border-radius: 3px;
        border: 1px solid;
        transition: all 0.15s ease;
        padding: 4px;
        max-width: 250px;
        line-height: 1;
        margin: auto;
        font-size: 0.8em;
    }

    .change-btn.active {
        background-color: #0871b8;
        color: #fff;
    }

    .change-btn.hidden {
        visibility: hidden;
    }

    .info {
        flex: 1 1 auto;
        line-height: 1.3;
        min-height: 2.6em;
        display: flex;
        align-items: center;
        text-align: left;
        margin-left: 1.2em;
        font-weight: bold;
        color: #4e4c4c;
    }


    .info-icon {
        margin-right: 1em;
    }

    .icono {
        width: 2.6em;
        min-width: 2.6em;
        height: 2.6em;
        display: flex;
        align-items: center;
    }

    .icono img {
        width: 100%;
        max-height: 100%;
    }

</style>
